import React from 'react';
import { motion } from 'framer-motion';
import MobileDemoPhone from '../../components/MobileDemoPhone';


const PositionedMobileDemoForWeb = ({ activeScreen, currentSection, isVisible }) => {
  // 애니메이션 설정 - isVisible에 따라 표시/숨김
  const getPhoneAnimation = () => {
    if (isVisible) {
      // home 시작 ~ passport 끝: 중앙 고정
      return {
        x: '-50%',
        y: '-50%',
        opacity: 1,
        scale: 1
      };
    } else if (!isVisible && currentSection < 2) {
      // App Menu 이전: 아래에 숨김
      return {
        x: '-50%',
        y: '100%',
        opacity: 0,
        scale: 0.8
      };
    } else {
      // App Menu 이후: 위로 사라짐
      return {
        x: '-50%',
        y: '-150%',
        opacity: 0,
        scale: 0.8
      };
    }
  };

  return (
    <motion.div
      className="fixed z-50 hidden lg:block pointer-events-none"
      style={{
        top: '50%',
        left: '50%',
      }}
      initial={{ x: '-50%', y: '100%', opacity: 0, scale: 0.8 }}
      animate={getPhoneAnimation()}
      transition={{ duration: 1.2, ease: [0.22, 0.61, 0.36, 1] }}
    >
      <div className="relative w-[280px] h-[600px] rounded-[2.75rem] p-[3px] shadow-2xl pointer-events-auto" style={{ background: 'linear-gradient(to bottom right, #3a3d2f, #2c2e24, #1f2019)' }}>
        {/* Local/Global Arrow Indicator - Above Phone Frame */}
        <motion.div
          className="absolute bottom-full mb-4 pointer-events-auto"
          style={{ 
            left: '0',
            width: '280px',
            height: '32px'
          }}
          initial={{ opacity: 0, y: 10 }}
          animate={{ 
            opacity: isVisible ? 1 : 0, 
            y: isVisible ? 0 : 10
          }}
          transition={{ duration: 0.5, delay: 0.3 }}
        >
          {/* Center - Menu Name (Fixed at exact center: 140px to align with logo) */}
          <div 
            className="absolute px-3 py-1 rounded-full bg-gradient-to-r from-[#FF7E5F]/20 via-white/10 to-[#38D4CC]/20 backdrop-blur-sm border border-white/20 shadow-md whitespace-nowrap"
            style={{
              left: '140px',
              top: '50%',
              transform: 'translate(-50%, -50%)'
            }}
          >
            <span className="text-xs font-bold text-gray-800">
              {activeScreen || 'home'}
            </span>
          </div>

          {/* Left Side - Local with Left Arrow */}
          <div 
            className="absolute flex items-center gap-1"
            style={{
              right: 'calc(50% + 60px)',
              top: '50%',
              transform: 'translateY(-50%)'
            }}
          >
            <motion.svg
              width="16"
              height="16"
              viewBox="0 0 24 24"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
              className="text-[#FF7E5F]"
              animate={{ x: [0, -3, 0] }}
              transition={{ duration: 1.5, repeat: Infinity, ease: "easeInOut" }}
            >
              <path
                d="M15 18L9 12L15 6"
                stroke="currentColor"
                strokeWidth="2.5"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
            </motion.svg>
            <span className="text-xs font-semibold text-[#FF7E5F]">local</span>
          </div>

          {/* Right Side - Global with Right Arrow */}
          <div 
            className="absolute flex items-center gap-1"
            style={{
              left: 'calc(50% + 60px)',
              top: '50%',
              transform: 'translateY(-50%)'
            }}
          >
            <span className="text-xs font-semibold text-[#38D4CC]">global</span>
            <motion.svg
              width="16"
              height="16"
              viewBox="0 0 24 24"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
              className="text-[#38D4CC]"
              animate={{ x: [0, 3, 0] }}
              transition={{ duration: 1.5, repeat: Infinity, ease: "easeInOut" }}
            >
              <path
                d="M9 18L15 12L9 6"
                stroke="currentColor"
                strokeWidth="2.5"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
            </motion.svg>
          </div>
        </motion.div>

        {/* Home Button Indicator */}
        <div className="absolute bottom-1.5 left-1/2 transform -translate-x-1/2 w-28 h-1 rounded-full" style={{ backgroundColor: '#4a4d3f' }}></div>

        {/* Phone Screen */}
        <MobileDemoPhone activeScreen={activeScreen} />

        {/* Hint below phone frame */}
        <motion.div
          className="absolute left-1/2 translate-x-[-50%] pointer-events-none select-none"
          style={{ bottom: '-50px' }}
          initial={{ opacity: 0 }}
          animate={{ opacity: isVisible ? 1 : 0 }}
          transition={{ duration: 0.6, delay: 0.4 }}
        >
          <motion.div
            className="px-3 py-1.5 rounded-full text-[12px] font-medium text-gray-800 bg-white/90 border border-gray-200 shadow whitespace-nowrap"
            initial={{ opacity: 0.95 }}
            animate={{ opacity: [0.95, 0.5, 0.95] }}
            transition={{ duration: 2.5, repeat: Infinity, ease: 'easeInOut' }}
          >
            ▲ 메뉴를 눌러보세요
          </motion.div>
        </motion.div>
      </div>
    </motion.div>
  );
};

export default PositionedMobileDemoForWeb;
